// extracted by mini-css-extract-plugin
module.exports = {"input":"IndustryForm_input__1ed_u","last":"IndustryForm_last__zRYg-","form":"IndustryForm_form__2Xx2l"};